import type { FC } from 'react';
import styles from '../styles/header.module.scss';

const Header: FC<{
    className?: string;
    title: string;
}> = ({ className = '', title }) => {
    return <div className={`${styles.headerMain} ${className}`}>{title}</div>;
};

export default Header;
